module.exports = "<template>\n\n    <div ref=\"calendar\"></div>\n\n</template>";